import type { ReactNode } from "react";
import { classes } from "../classes.ts";
import styles from "./Card.module.css";

export function Card({ children, className }: { readonly children: ReactNode; readonly className?: string | undefined }) {
  return <div className={classes(styles.card, className)}>{children}</div>;
}
